const validationMixin = {
    methods: {
        getValidationState({dirty, validated, valid = null}) {
            return dirty || validated ? valid : null;
        },
    }
}
export default validationMixin
